/* Quiet quick-add for the range cards (sb-carousel-card.liquid).
   Adds the card's default variant to the cart WITHOUT opening the cart
   drawer or notification (owner direction 2026-07-17): the only visible
   feedback is the header cart bubble updating and the button's brief ✓
   state. The closed drawer is re-rendered in the background so it is ready
   if opened immediately afterwards. Publishes Dawn's cartUpdate pub/sub
   event so cart-page items, upsells and analytics subscribers stay in sync. */
(function () {
  'use strict';
  if (window.SBQuickAddBound) return;
  window.SBQuickAddBound = true;

  function updateBubble(sectionHtml) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var section = doc.querySelector('.shopify-section') || doc.body;
    bubble.innerHTML = section.innerHTML;
    bubble.classList.remove('site-actions__cart--empty');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sb-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    // In-flight / just-added guard: also spaces out mutations, since
    // /cart/*.js rate-limits bursts hard.
    if (button.getAttribute('aria-disabled') === 'true' || button.classList.contains('is-added')) return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    button.classList.remove('is-error');
    var status = button.querySelector('[data-sb-quick-add-status]');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message);
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response, false);
        } else {
          updateBubble(response.sections && response.sections['cart-icon-bubble']);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sb-quick-add',
            productVariantId: String(button.dataset.variantId),
            cartData: response,
          });
        }
        button.classList.add('is-added');
        if (status) status.textContent = button.dataset.textAdded || '';
        window.setTimeout(function () {
          button.classList.remove('is-added');
          if (status) status.textContent = '';
        }, 2000);
      })
      .catch(function () {
        button.classList.add('is-error');
        window.setTimeout(function () { button.classList.remove('is-error'); }, 2000);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
      });
  });
})();
